/**
 * Specifies the valuation type applicable to the return rate date.
 * tag: 42710
 * @readonly
 * @enum {number} (int)
 */
export enum ReturnRateDateMode {
  /** Price valuation */
  PriceValuation = 0,
  /** Dividend valuation */
  DividendValuation = 1,
}
